import { render, staticRenderFns } from "./FinancialPosts.vue?vue&type=template&id=65fc06ef&scoped=true"
import script from "./FinancialPosts.vue?vue&type=script&lang=js"
export * from "./FinancialPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc06ef",
  null
  
)

export default component.exports